module.exports = __webpack_public_path__ + "img/balkonbruestung_2.ac1028eb.jpg";